import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { OfferKind } from '@recruitee/offers-types';
import type { TOfferKind } from '@recruitee/offers-types';

import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'rt-offer-status-indicator',
  templateUrl: './offer-status-indicator.component.html',
  styleUrls: ['./offer-status-indicator.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'className',
  },
  imports: [IconComponent],
})
export class OfferStatusIndicatorComponent {
  public showTalentPoolsIcon: boolean;
  public className: string;

  @Input()
  public set offerStatus(offerStatus: { kind: TOfferKind; status: string }) {
    this.showTalentPoolsIcon = offerStatus.kind === OfferKind.TalentPool;
    this.className = offerStatus.kind === OfferKind.TalentPool ? 'talent-pool' : offerStatus.status;
  }
}
